import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push,
  replace
} from 'react-router-redux';
import {
  Button,
  Dropdown,
  Form,
  Grid,
  Header,
  Icon,
  Label,
  List,
  Menu,
  Message,
  Modal,
  Segment
} from 'semantic-ui-react';
import {
  Link
} from 'react-router-dom';
import feathersConnect from './../../../providers/feathersConnect';
import usersActions from './../../../store/actions/usersActions';
import {
  createInputHandler
} from './../../../helpers/utils';
import {
  includes,
  without
} from 'lodash';
import UsersForm from './UsersForm';
import NavPages from './../../navigation/NavPages';
import UsersFilterModal from './UsersFilterModal';

const PAGE_RANGE = 5;

class UsersView extends Component {

  constructor (props) {
    super(props);
  }

  componentDidMount () {
    this.findUsers();
  }

  onUpsertModalClose = () => {
    this.props.toggleUpsertModal();
    this.props.resetForm();
  }

  pageChange = (page) => {
    let limit = (page + 1) * PAGE_RANGE;
    let skip = page * PAGE_RANGE;

    this.findUsers(limit, skip);
  }

  changeRolesFilter = (e, checkbox) => {
    let {
      filters: {
        roles
      }
    } = this.props.users.records;
    let updatedRoles = [];

    if (checkbox.checked) {
      updatedRoles = roles.concat([checkbox.value]);
    } else {
      updatedRoles = without(roles, checkbox.value);
    }

    this.props.setFilter('roles', updatedRoles);
  }

  findUsers = (lmt = null, skp = null) => {
    let {
      records: {
        filters,
        limit,
        skip
      }
    } = this.props.users;

    this.props.findUsersAttempt(filters, lmt || limit, skp !== null ? skp : skip);
  }

  selectUser = (user) => {
    this.props.selectUserForEdit(user);
    this.props.toggleUpsertModal();
  }

  dismissFilters = () => {
    this.props.toggleFiltersModal();
  }

  applyFilters = () => {
    this.props.toggleFiltersModal();
    this.findUsers();
  }

  submitSearch = (e) => {
    e.preventDefault();

    this.findUsers();
  }

  formSubmit = (e) => {
    e.preventDefault();

    this.props.upsertUser(this.props.users.form.values);
  }

  static mapStateToProps (state) {
    return {
      users: state.users.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      findUsersAttempt: (criteria, limit, skip) => {
        dispatch(usersActions.users.findAttempt(criteria, limit, skip));
      },
      removeUserAttempt: (id) => {
        dispatch(usersActions.users.removeAttempt(id));
      },
      changeFormValue: (name, value) => {
        dispatch(usersActions.users.changeFormValue(name, value));
      },
      resetForm: () => {
        dispatch(usersActions.users.resetForm());
      },
      upsertUser: (values) => {
        dispatch(usersActions.users.upsertAttempt(values));
      },
      selectUserForEdit: (values) => {
        values.roles = values.roles.map(role => role.name);

        dispatch(usersActions.users.fillForm(values));
      },
      toggleUpsertModal: () => {
        dispatch(usersActions.users.toggleUpsertModal());
      },
      toggleFiltersModal: () => {
        dispatch(usersActions.users.toggleFiltersModal());
      },
      setFilter: (name, value) => {
        dispatch(usersActions.users.setFilter(name, value));
      }
    };
  }

  render () {
    let {
      users
    } = this.props;

    return (
      <div>
        <Menu attached="top">
          <Menu.Item icon="filter" content="Filtrar" onClick={this.props.toggleFiltersModal.bind(null)} />
          <Menu.Item icon="refresh" onClick={this.findUsers.bind(null, null, null)} />

          <Menu.Menu position="right">
            <div className="ui right aligned category search item">
              <form onSubmit={this.submitSearch} className="ui transparent icon input">
                <input
                  className="prompt" type="text" placeholder="Buscar usuarios ..."
                  value={users.records.filters.text} onChange={e => this.props.setFilter('text', e.target.value)} />
                <i className="search link icon" />
              </form>
              <div className="results"></div>
            </div>
          </Menu.Menu>
        </Menu>

        {
          users.records.error &&
            <Message negative attached>
              <Message.Header>Error {users.records.error.code}!</Message.Header>
              <p>{users.records.error.message}</p>
            </Message>
        }

        <Segment loading={users.records.loading} attached>
          <List divided relaxed>
            {
              users.records.data.map((user, index) => {
                return (
                  <List.Item key={index}>
                    <List.Content floated="right">
                      <Button negative basic icon="trash" onClick={this.props.removeUserAttempt.bind(null, user.id)} />
                    </List.Content>
                    <List.Content>
                      <List.Header as="a" onClick={this.selectUser.bind(null, user)}>{user.name}</List.Header>
                      <List.Description as="a">
                        {user.email} - {user.roles.map((role, index) => <Label key={index}>{role.commonName}</Label>)}
                      </List.Description>
                    </List.Content>
                  </List.Item>
                );
              })
            }
          </List>
        </Segment>
        <Segment clearing attached="bottom">
          <Button primary content="Nuevo" icon="add" onClick={this.props.toggleUpsertModal.bind(null)} />
          <NavPages
            floated="right" pageChange={this.pageChange.bind(null)}
            selected={users.records.skip / PAGE_RANGE} itemsPerPage={PAGE_RANGE} total={users.records.total} />
        </Segment>
        <Modal
          closeOnEscape={false} closeOnDimmerClick={false}
          size="small" open={users.upsertModal} onClose={this.onUpsertModalClose.bind(null)}>
          <Modal.Header>Crear/Editar Usuario</Modal.Header>
          <Modal.Content>
            <UsersForm
              onSubmit={this.formSubmit} onDismiss={this.onUpsertModalClose.bind(null)} submitting={users.form.submitting}
              values={users.form.values} createInputHandler={createInputHandler.bind(this)} error={users.form.error} />
          </Modal.Content>
        </Modal>
        <UsersFilterModal
          open={users.filtersModal}
          filters={users.records.filters}
          changeRolesFilter={this.changeRolesFilter}
          dismissFilters={this.dismissFilters}
          applyFilters={this.applyFilters} />
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    UsersView.mapStateToProps,
    UsersView.mapDispatchToProps
  )(UsersView)
);



// WEBPACK FOOTER //
// ./client/components/pages/system/UsersView.js